import { bindable, capture } from "aurelia";

@capture((attrs) => attrs !== "id" && attrs !== "label" && attrs !== "disabled" && attrs !== "validate")
export class InputAdvancedComponent {
  public id: string = crypto.randomUUID();

  @bindable public validate: boolean = false;

  @bindable label: string;
  @bindable helper: string;
  @bindable hint: string;
  @bindable maxLength: number;
  @bindable icon: string;
  @bindable iconFunction: Function;
  @bindable disabled: boolean = false;
  @bindable inputType:
    | 'label'
    | 'label-icon'
    | 'label-button-icon'
    | 'none'
    | 'label-inside'
    | 'label-inside-button-icon'
    | 'button-icon';

  private inputElement: HTMLInputElement;

  attached() {
    this.inputElement = document.getElementById(this.id) as HTMLInputElement
  }

  get hasLabelInside() {
    return ['label-icon', 'label-inside', 'label-inside-button-icon'].includes(this.inputType);
  }

  get hasIconButton() {
    return ['button-icon', 'label-button-icon', 'label-inside-button-icon'].includes(this.inputType);
  }

  async executeIconFunction() {
    this.iconFunction?.();
  }

}
